exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-sort .sort-toggle-btn[data-v-b1ea1a86]{max-width:250px;min-height:auto;height:auto;padding-left:.625rem;padding-right:.625rem;border:1px solid transparent;font-weight:var(--inistate-font-weight-light);font-size:var(--inistate-label-text-14);line-height:var(--inistate-paragraph-text-14--line-height);letter-spacing:normal}.fts-sort .sort-toggle-btn svg[data-v-b1ea1a86]{margin-left:.5rem;margin-right:0}.fts-sort .sort-toggle-btn.sort-toggle-btn--active[data-v-b1ea1a86],.fts-sort .sort-toggle-btn[data-v-b1ea1a86]:hover{border-color:var(--fts-form-control-border)}", ""]);

// exports
